import { render, staticRenderFns } from "./PartnersGraph.vue?vue&type=template&id=c96ea802"
import script from "./PartnersGraph.vue?vue&type=script&lang=js"
export * from "./PartnersGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports